import { FC } from 'react';

import { OverlayDummyContent } from 'src/components/common/Overlay/OverlayDummyContent';

export const TeamOrMemberOverlayDummyContent: FC = () => (
  <OverlayDummyContent>
    <div className="campaign-management-overlay-banner">
      <div className="banner">
        <div className="media" />
        <div className="block1" />
        <div className="block2" />
        <div className="block3" />
        <div className="block4" />
        <div className="block4" />
        <div className="block4" />
        <div className="block5">
          <div className="circle" />
          <div className="circle" />
          <div className="circle" />
          <div className="circle" />
        </div>

        <div className="block6" />
      </div>
    </div>
    <div className="campaign-management-overlay-scrolling-container2">
      <div className="campaign-management-overlay-scrolling-content">
        <div className="table">
          <div className="block1" />
          <div className="block2" />
          <div className="block3" />
          <div className="block4" />
        </div>
      </div>
    </div>
  </OverlayDummyContent>
);
